import { Group, Skeleton, Stack } from '@mantine/core'
import ContactCardSkeleton from './ContactCardSkeleton'

type SkeletonProps = {
  withContactCard?: boolean
}

export default function BoxSkeleton({ withContactCard = false }: SkeletonProps) {
  return (
    <Stack gap={'xl'} style={{ borderRadius: 'var(--mantine-radius-sm)' }} bd="1px solid light-gray.6" w="100%" p="lg">
      <Skeleton height={30} width="70%" />

      {/* Box with contact card skeleton */}
      {withContactCard ? (
        <ContactCardSkeleton />
      ) : (
        <>
          {/* Normal box data skeleton */}
          <Stack gap={7}>
            <Skeleton height={20} width="80%" />
            <Group gap={5}>
              <Skeleton height={15} width={15} />
              <Skeleton height={15} width="74%" />
            </Group>
          </Stack>
          <Stack gap={7}>
            <Skeleton height={20} width="80%" />
            <Group gap={5}>
              <Skeleton height={15} width={15} />
              <Skeleton height={15} width="74%" />
            </Group>
          </Stack>
        </>
      )}
    </Stack>
  )
}
